export interface DaySchedule {
  enabled: boolean;
  startTime: string; // "HH:MM" format
  endTime: string;   // "HH:MM" format
}

export interface Class {
  id?: number;
  className: string;
  teacher: string;
  classRoom?: string;
  classCategory?: "regular" | "special" | "supplement";
  classStartDate?: string | null;
  classEndDate?: string | null;
  classDescription?: string | null;
  monday?: boolean;
  mondayStartTime?: string | null;
  mondayEndTime?: string | null;
  tuesday?: boolean;
  tuesdayStartTime?: string | null;
  tuesdayEndTime?: string | null;
  wednesday?: boolean;
  wednesdayStartTime?: string | null;
  wednesdayEndTime?: string | null;
  thursday?: boolean;
  thursdayStartTime?: string | null;
  thursdayEndTime?: string | null;
  friday?: boolean;
  fridayStartTime?: string | null;
  fridayEndTime?: string | null;
  saturday?: boolean;
  saturdayStartTime?: string | null;
  saturdayEndTime?: string | null;
  sunday?: boolean;
  sundayStartTime?: string | null;
  sundayEndTime?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export const defaultClass: Class = {
  className: "",
  teacher: "",
  classRoom: "",
  classStartDate: null,
  classEndDate: null,
  classDescription: "",
  monday: false,
  mondayStartTime: "00:00",
  mondayEndTime: "00:00",
  tuesday: false,
  tuesdayStartTime: "00:00",
  tuesdayEndTime: "00:00",
  wednesday: false,
  wednesdayStartTime: "00:00",
  wednesdayEndTime: "00:00",
  thursday: false,
  thursdayStartTime: "00:00",
  thursdayEndTime: "00:00",
  friday: false,
  fridayStartTime: "00:00",
  fridayEndTime: "00:00",
  saturday: false,
  saturdayStartTime: "00:00",
  saturdayEndTime: "00:00",
  sunday: false,
  sundayStartTime: "00:00",
  sundayEndTime: "00:00",
};

